/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'log',
})
export class LogPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (args.length) {
      console.log(...args, value);
    } else {
      console.log(value);
    }
    return value;
  }
}
